import { CompositeScreenProps, useNavigation } from '@react-navigation/native'
import React, { useState } from 'react'

import { DescriptionInput } from 'pages/CoachOnboarding/subcomponents/DescriptionInput'

import { BottomSheetNav } from 'widgets/BottomSheetNav'
import { Box } from 'widgets/Box'

import { links } from 'utils/constants'

import { Program } from 'types/program'

export const ProgramDescriptionPage = ({ route }: CompositeScreenProps<any, any>) => {
  const programData = route?.params?.program as Program | undefined

  const navigation = useNavigation<any>()

  const [description, setDescription] = useState<string | null>()

  const handleNextPress = () => {
    if (!description?.length) return
    if (!programData) return
    programData.description = description ?? ''
    navigation.navigate(links.PROGRAM_NAME_PAGE, {
      program: programData,
    })
  }

  return (
    <Box flex={1} backgroundColor='white'>
      <BottomSheetNav
        withNext
        withBack
        rightButtonTitle='Next'
        rightButtonColor={description?.length ? 'v2primary' : 'grey'}
        backgroundColor='white'
        onNextPress={handleNextPress}
      />
      <DescriptionInput
        input={description}
        setInput={setDescription}
        textColor='black'
        promptTitle='Tell us about your program.'
        promptSubtitle='This is what your customers can read before they join your program so put whatever you want them to know here.'
        inputPlaceholder='Description'
      />
    </Box>
  )
}
